import { WebsitePlugin } from '@gift/types/WebsitePlugin';
import { createPluginRegistry } from './createPluginRegistry';
import { RenderingPlugin } from '@gift/types/RenderingPlugin';

export const scenePlugins = createPluginRegistry<WebsitePlugin.Scene<any, any, any>>();
export const variablePlugins = createPluginRegistry<WebsitePlugin.Variable<any, any>>();
export const renderingPlugins = createPluginRegistry<RenderingPlugin.Scene<any, any, any>>()